import { render, staticRenderFns } from "./ExtBizLeaveModal.vue?vue&type=template&id=49df0c68&scoped=true&"
import script from "./ExtBizLeaveModal.vue?vue&type=script&lang=js&"
export * from "./ExtBizLeaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df0c68",
  null
  
)

export default component.exports